import React, { useEffect, useRef } from 'react';
import '../Style.css';

const allProjects = [
  {
    title: "Bit Dials",
    link: "https://bitdials.eu/",
    img: "/Images/app1.webp",
    desc: "BitDials.eu is an online luxury boutique that specializes in selling high-end luxury watches and other luxury goods using digital currency, particularly Bitcoin.",
  },
  {
    title: "American HVAC",
    link: "https://aairhvac.com/",
    img: "/Images/app2.webp",
    desc: "We specialize in providing top-tier heating and cooling solutions that keep your home or business comfortable all year round.",
  },
  {
    title: "Lego Desk",
    link: "https://legodesk.com/",
    img: "/Images/app3.webp",
    desc: "Lego Desk simplifies legal processes to keep you competitive, offering automation, delinquency tracking, and collaboration tools.",
  },
  {
    title: "Bitsky",
    link: "https://bitsky.world/",
    img: "/Images/app4.webp",
    desc: "BitSky manages your private business jet flight and also takes care of gourmet catering, transport, and hotel bookings.",
  },
  {
    title: "Justin Colon",
    link: "https://justincolonbooks.com/",
    img: "/Images/app5.webp",
    desc: "Justin Colón is a children's author and professional actor offering books and editorial services.",
  },
  {
    title: "American AIRHVAC",
    link: "https://install.aairhvac.com/",
    img: "/Images/Airhvaclanding.webp",
    desc: "Professional heating, ventilation, and air conditioning services with a clean landing page.",
  },
  {
    title: "Velantra Hotel",
    link: "https://velantrahotel.hatchcoders.com/",
    img: "/Images/velantra_hotel.webp",
    desc: "Velantra Hotel offers a luxurious and serene escape, blending modern comfort with timeless elegance.",
  },
    {
    title: "Yummigo",
    link: "https://yummigo.hatchcoders.com/",
    img: "/Images/yummigo.webp",
    desc: "Yummigo is your go-to destination for discovering mouth-watering recipes, fresh culinary inspiration, and food tips that elevate every meal. From quick bites to gourmet dishes, we bring flavors from around the world right to your kitchen.",
  },
    {
    title: "Elevate Estates",
    link: "https://elevate-estates.hatchcoders.com/",
    img: "/Images/elevate-estate.webp",
    desc: "Elevate Estates is your trusted partner in finding premium residential and commercial properties. We specialize in modern real estate solutions that combine style, comfort, and smart investment.",
  }
];

const Portfolio = ({ limit, showViewAll }) => {
  const h1Ref = useRef(null);
  const pRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry], observerInstance) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observerInstance.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (h1Ref.current) observer.observe(h1Ref.current);
    if (pRef.current) observer.observe(pRef.current);

    return () => observer.disconnect();
  }, []);

  const displayedProjects = limit ? allProjects.slice(0, limit) : allProjects;

  return (
    <>
      <div className="tut">
        <h1 className="slide-up h1-active" ref={h1Ref}>Here are few our recent works</h1>
        <p className="slide-up p-active" ref={pRef}>The wise man therefore always holds in these matters to this principle of selection.</p>
      </div>

      <div className="container">
        {showViewAll && (
          <div className="btn1">
            <a href="/portfolio">
              <button>View All <img src='/Images/arrow1.webp' alt='arrow' /></button>
            </a>
          </div>
        )}

        <div className="service">
          {displayedProjects.map((proj, index) => (
            <div className="ser" key={index}>
              <a target="_blank" href={proj.link}>
                <img width={560} src={proj.img} alt={proj.title} />
                <h2>{proj.title}</h2>
                <p>{proj.desc}</p>
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Portfolio;
